import React, { Component } from 'react';
import { Container } from 'reactstrap';
import ContentLoader from "../../components/ContentLoader";
import MetaTags from '../../components/SEO/MetaTags'
import { Request } from '../../helpers/request'
import { addLocalePrefix } from '../../components/Routes/LocaleLink'

class LegalNoticePage extends Component
{
    state = {
        data: null
    };

    componentDidMount() {
        this.fetch();
    }

    fetch() {
        Request.get('legal')
            .then((data) => {
                this.setState({ data })
            })
            .catch((e) => {
                this.props.history.push(addLocalePrefix('/404'));
            });
    }

    renderContent = () =>
    {
        const {data} = this.state;

        if (!data)
            return <ContentLoader/>;

        return (
            <>
                <h1 className="line-heading">
                    { data.title }
                </h1>
                <div className='notice-text' dangerouslySetInnerHTML={{__html: data.content}}/>
            </>
        )
    };

    render()
    {
        return (
            <div className="legal-notice-page">

                <MetaTags page="legal" />

                <section className="section-notice">
                    <Container>
                        {this.renderContent()}
                    </Container>
                </section>
            </div>
        )
    }
}

export default LegalNoticePage;
